import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import Card from 'components/Card';
import { benefitsCards } from 'sections/DigitalTools/ShipSchedules/data';
import { BenefitCard } from 'sections/DigitalTools/ShipSchedules/types';
import styles from 'sections/DigitalTools/ShipSchedules/components/SectionBenefits/SectionBenefits.module.scss';

const cn = classNames.bind(styles);

const SectionBenfits = (): ReactElement => {
  const cardsElements = benefitsCards.map((card: BenefitCard) => {
    return (
      <Card className={cn('card')} key={card.id}>
        <div className={cn('card__content')}>
          <Card.Header className={cn('card__heading-box')}>
            <img
              className={cn('card__icon')}
              src={`/images/pages/DigitalTools/ShipSchedules/${card.icon}`}
              alt={card.alt}
            />
            <h4 className={cn('card__heading')}>
              <span>{card.title.firstLine}</span>{' '}
              <span>{card.title.secondLine}</span>
            </h4>
          </Card.Header>
          <Card.Content className={cn('card__description')}>
            <p>{card.description}</p>
          </Card.Content>
        </div>
      </Card>
    );
  });

  return (
    <section className={cn('benefits')}>
      <div className={cn('container')}>

        <h2 className={cn('benefits__heading')}>
          Benefits for Freight Forwarders
        </h2>

        <div className={cn('benefits__cards')}>
          {cardsElements}
        </div>

      </div>
    </section>
  );
};

export default SectionBenfits;